import { render } from "./LorealProjectThree.vue?vue&type=template&id=81d94330"
import script from "./LorealProjectThree.vue?vue&type=script&lang=js"
export * from "./LorealProjectThree.vue?vue&type=script&lang=js"

import "./LorealProjectThree.vue?vue&type=style&index=0&id=81d94330&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__